(function() {
    class Product {
        async getOfferId(id) {
            let relations = await App.Interface.Api.promise('productprimaryoffer');
            let relation = relations.find(items => items['product_id'] == id);
            if (relation === undefined) return undefined;
            return parseInt(relation['primaryOffer_id']);
        }

        /*
        * @return array;
        */
        async getOffers(productId) {
            /* Get offers from API */
            let offers = await App.Interface.Api.promise(
                ['productoffers', productId].join('/'), {}, {cache: true}
            );
            /* Sort offers from cheap to expensive  */
            offers.sort(function (a, b) {
                return a['price'] - b['price'];
            });
            /* Remove unusable offers */
            offers = offers.filter(offer => {
                if (offer.price > 0 && offer.availability !== 0) return true;
            });
            return offers;
        }

        /*
        * @return array;
        */
        async getFamiliarProducts(productId) {
            return await App.Interface.Api.promise(
                ['products', productId, 'familiar'].join('/'), {}, {cache: true}
            );
        }

        async getFormatedValues(productId = null, designId = null) {
            const product   = await App.Endpoint.Products.getById(productId);
            const design    = await App.Endpoint.Designs.getById(designId);

            let total = await product?.mixedNettPrice || 0;
            total += design?.price || 0;
            total = (Math.ceil(total * 100) / 100).toFixed(2);
            const weight = product?.weight || 0;
            return {
                product:        product?.id,
                design:         design?.id,
                weight:         weight,
                price:          total,
                total:          App.Interface.Currency.format(total),
                productPrice:   App.Interface.Currency.format(await product?.mixedNettPrice || 0),
                designPrice:    design?.priceFormatted,
                gramPrice:      App.Interface.Currency.format((total  / weight) * 1000),
            };
        }

        /*
        * @return array;
        */
        async getRecommendations(productId, total = 10) {
            let products = [];
            /* FAMILIAR PRODUCTS */
            let familiarProducts = await this.getFamiliarProducts(productId);
            familiarProducts.forEach(item => {
                if (products.length < total && item.hasAvailableOffers) products.push(item.id);
            });
            /* TOP PRODUCTS */
            // @todo: Search Interface should deliver the top Products
            if (products.length < total && App.Components.Search !== undefined && App.Components.Search.data) {
                let result = App.Components.Search.data;
                result = result.filter(function(element) {
                    if (element.type === 'product') {
                        return true;
                    }
                });
                result.sort(function(a, b) {
                    return a.popularity - b.popularity;
                });
                result.slice(0, total).forEach(function(item) {
                    if (products.length < total) products.push(item.id);
                });
            }
            return products;
        }

        /**
         * @param id
         * @param defaultReturn When product not in the API mat be necessary to return true
         * @return {boolean|*}
         */
        async getAvailability(id, defaultReturn = false) {
            const product = await App.Endpoint.Products.getById(id);
            if (product) return product.hasAvailableOffers;
            return defaultReturn;
        }
    }
    App.Interface.Product = new Product();
})();
